import { create } from 'zustand';

/**
 * Whether the open thread's outcome popover is open (Task 3.2): the inbox's
 * `o` shortcut and the command palette open it, the thread header shows it.
 */
interface OutcomeRequest {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useOutcomeRequest = create<OutcomeRequest>()((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
